import WarehouseIcon from "@redotech/redo-icons/warehouse.svg";
import { RedoOutboundLabelsRpcClient } from "@redotech/redo-merchant-fulfillment-rpc/client";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

interface FulfillmentServiceOption {
  _id: string;
  name: string;
}

export const AssignedFulfillmentServiceFilter = (
  rpcClient: RedoOutboundLabelsRpcClient,
): ArrayStringTableFilter<FulfillmentServiceOption | string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  itemLabel: "fulfillment service",
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "assignedFulfillmentService",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: WarehouseIcon,
  valueFetcher: async (_filters, signal) => {
    const { fulfillmentServices } =
      await rpcClient.getFulfillmentServicesThatFulfillForTeam({}, { signal });
    return fulfillmentServices;
  },
  itemGenerator: (item) => ({
    id: typeof item === "string" ? item : item._id,
    value: item,
    type: "text",
    text: typeof item === "string" ? item : item.name,
  }),
  stringify: (item) => (typeof item === "string" ? item : item._id),
  display: (item) => (typeof item === "string" ? item : item.name),
  displayName: "Fulfillment service",
});
